import React from 'react'
import BEMHelper from 'react-bem-helper'

import { Grid, Col } from '../../components/Grid'
import List from '../../components/List'
import Contact from '../../components/Contact'

import vippslogo from '../../images/cases/vipps_logo_rgb.png'
import netlifelogo from '../../images/cases/netlife-logo.png'
import vippscreenshot from '../../images/cases/vipps-macbook-vs-samsung-tables-room-small.png'

import './index.css'
import cases from '../../data/cases'
import Helmet from '../../components/seo/Helmet'

const classes = new BEMHelper('vipps')

export default function Vipps ({ helmetProps }) {
  const info = cases.find(({ slug }) => slug === 'vipps')
  const { name, preamble, description } = info

  return (
    <article>
      <Helmet {...helmetProps} />
      <Grid>
        <Col>
          <h1 {...classes('title')}>{name}</h1>
        </Col>
      </Grid>

      <Grid>
        <Col>
          <p>
            <em>{preamble}</em>
          </p>
          <img src={vippscreenshot} alt="Vipps.no screenshot" {...classes('screenshot')} />

          <p dangerouslySetInnerHTML={{ __html: description.props.children }} />

          <img src={vippslogo} alt="Vipps logo" {...classes('logo')} />


        </Col>
        <Col>
          <p>
            Vipps er det ledende selskapet innen smartbetaling i Norge.
            I forbindelse med sammenslåingen av Vipps, BankID og BankAxept ønsket de nye
            nettsider og nytt publiseringssystem.
          </p>
          <img src={netlifelogo} alt="Netlife logo" {...classes('screenshot')} />

          <p>
            Appresso har sammen med Netlife og Scandinavian Design Group laget de nye nettsidene.
            Sidene er bygget med Wagtail og ReactJS.
          </p>
          <List>
            <li>
              <a
                href="https://vipps.no"
                target="_blank"
                rel="noopener noreferrer"
              >
                Vipps.no
              </a>
            </li>
            <li>
              <a
                href="https://www.netlife.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Netlife
              </a>
            </li>
            <li>
              <a
                href="https://sdg.no/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Scandinavian Design Group
              </a>
            </li>
          </List>
        </Col>
      </Grid>

      <Contact
        who="tor"
        title="Vil du ta en prat om det vi har gjort for Vipps?"
      >
        Ta kontakt med <strong>Tor Ivar</strong> om du lurer mer på hva vi har
        gjort for Vipps.
      </Contact>
    </article>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Vipps/index.js